import { createAction } from "@reduxjs/toolkit"
import { PanelNames } from "panels/constants"
import { withActionPrefix } from "./constants"
import { SetPanelModePayload } from "./types"

export const setPanelModeAction = createAction<SetPanelModePayload>(withActionPrefix("setMode"))

export const restoredFromSuspenseMemoryAction = createAction(
    withActionPrefix("restoredFromSuspenseMemory")
)
export const suspendedVisibilityAction = createAction<PanelNames[]>(
    withActionPrefix("suspendedVisibility")
)
